<!-- filepath: /Users/desarrollo/Documents/Proyectos/friax/src/App.vue -->
<template>
  <div id="app" class="bColor">
    <main class="content">
      <router-view />
    </main>
  </div>
</template>
<style>
.bColor {
  height: 100vh;
  background-color: #54789A;
}
</style>